namespace TabAurous.Production {
    export namespace WIPMovementSelectForMergingService {
        export const baseUrl = 'Production/WIPMovementSelectForMerging';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WIPMovementSelectForMerging/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>WIPMovementSelectForMergingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
